import React, { useState } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import { Link } from "react-scroll";

const Navbar = () => {
  const [nav, setNav] = useState(false);

  const links = [
    {
      id: 1,
      link: "home",
    },
    {
      id: 2,
      link: "about",
    },
    {
      id: 3,
      link: "portfolio",
    },
    {
      id: 4,
      link: "SkillStack",
    },
    {
      id: 1,
      link: "contact",
    },
  ];

  return (
    <div className="flex justify-between items-center sticky top-0 w-full h-20 md:py-4 px-5 bg-black text-white shadow-lg  shadow-gray-700 z-10">
      <h1 className="lg:text-5xl text-3xl font-playfair ml-2">Mohd Zubair Alam Ansari</h1>

      <ul className="hidden lg:flex ">
        {links.map(({ id, link }) => (
          <li
            key={id}
            className="px-4 cursor-pointer font-medium capitalize text-gray-500 hover:scale-105 duration-200"
          >
            <Link to={link} 
                  smooth
                  duration={500}
                  > 
                  {link}
                  </Link>
          </li>
        ))}
      </ul>
      <div
        onClick={() => setNav(!nav)}
        className="cursor-pointer pr-4 z-10 text-gray-500 lg:hidden"
      >
        {nav ? <FaTimes size={30} /> : <FaBars size={30} />}
      </div>
      {nav && (
        <ul className="flex flex-col justify-center items-center absolute top-0 left-0 w-full h-screen bg-gradient-to-b from-black to-gray-800 text-gray-500 ">
          {links.map(({ id, link }) => (
            <li
              key={id}
              className="px-4 cursor-pointer capitalize py-6 text-4xl "
            >
              <Link onClick={() => setNav(!nav)}
                    to={link} 
                    smooth 
                    duration={500}>
                {link}
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default Navbar;
